import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

import moment from 'moment'

class SchoolYearsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      startDate: '',
      endDate: '',
      showModal: false,
      schoolYearId: ''
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    const data = {
      name: this.state.name,
      code: this.state.code,
      startDate: this.state.startDate,
      endDate: this.state.endDate
    };
    this.props.handleUpdate(data,this.state.schoolYearId);
    this.setState({
      name: '',
      code: '',
      startDate: '',
      endDate: '',
      showModal: false,
      schoolYearId: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      name: this.props.schoolYear.name,
      code: this.props.schoolYear.code,
      startDate: moment(this.props.schoolYear.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.props.schoolYear.endDate).format('YYYY-MM-DD'),
      schoolYearId: this.props.schoolYear.schoolYearId
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.schoolYear.name,
      code: newProps.schoolYear.code,
      startDate: moment(newProps.schoolYear.startDate).format('YYYY-MM-DD'),
      endDate: moment(newProps.schoolYear.endDate).format('YYYY-MM-DD'),
      schoolYearId: newProps.schoolYear.schoolYearId
    })
  }

  render() {

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='pencil' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Edit a School Year</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>Start Date</label>
                <Input value={this.state.startDate} name='startDate' type='date' placeholder='Start Date' onChange={this.handleChange}/>
              </Form.Field>
              <Form.Field>
                <label>End Date</label>
                <Input value={this.state.endDate} name='endDate' type='date' placeholder='endDate' onChange={this.handleChange}/>
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SchoolYearsEdit;
